import * as React from 'react';
import { st, classes } from './Divider.st.css';
import { DividerProps } from './types';

export const Divider = (props: DividerProps) => {
  const { className, direction = 'horizontal', ariaHidden } = props;
  return (
    <hr
      data-hook={props['data-hook']}
      className={st(classes.root, { direction }, className)}
      aria-hidden={ariaHidden}
    />
  );
};
